import React, { useContext, useEffect, useState } from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { POST_SALE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsPostSale';
import { isSSR } from 'Utilities/helpers';
import { safeLocalStorage } from 'Utilities/storages';

import { Modal } from 'Storybook/components/local/Modal/Modal';

import CarCelebrate from '../../../../../../client/assets_seller/documentCapture/celebrate-car.svg';
import { POST_SALE_COMPLETED_SALE_KEY } from '../../../postSale/helpers/DocumentCapture.helpers';
import { useVehicleCollectionSub } from '../../../vehicleCollection/hooks/useVehicleCollectionSub';
import { DocumentCaptureOfferContext } from '../../DocumentCaptureContexts';

import LocalTexts from './SaleApprovedModal.texts.json';

import styles from './SaleApprovedModal.scss';

const LocalT = new MDText(LocalTexts);

export const SaleApprovedModal = () => {
  const { acceptedBid, enquiryId: enquiryIdFromDocumentCaptureContext } = useContext(DocumentCaptureOfferContext) || {};
  const { enquiryId: enquiryIdFromVehicleCollectionSub, offer } = useVehicleCollectionSub();

  const enquiryId = enquiryIdFromDocumentCaptureContext ?? enquiryIdFromVehicleCollectionSub;
  const dealerName = acceptedBid?.dealer?.name ?? offer?.acceptedBid?.dealer?.name;

  const subtext = LocalT.translate('subtext', { dealerName: dealerName ? `, ${dealerName}` : '' });

  /**
   * We check if enquiryId is in localStorage.
   * If its not in localStorage yet, the modal will show
   *
   * N.B Maybe we need to clear localStorage in Document Capture
   * in case of deal collapsing and resold?
   */
  const saleCompletedEnquiries = !isSSR() ? (safeLocalStorage.getItem(POST_SALE_COMPLETED_SALE_KEY) || []) : [];
  const modalShown = !!saleCompletedEnquiries.includes(enquiryId);

  const [openModal, setOpenModal] = useState<boolean>(!modalShown);

  useEffect(() => {
    setOpenModal(!modalShown);
  }, [modalShown]);

  const closeModal = () => {
    const vehiclesCompleted = [...new Set([...saleCompletedEnquiries, enquiryId])];
    safeLocalStorage.setItem(POST_SALE_COMPLETED_SALE_KEY, vehiclesCompleted);
    POST_SALE_SNOW_PLOW_EVENTS.VIEW_SALE_DETAILS_MODAL_CLOSED();

    setOpenModal(false);
  };

  return (openModal ? <Modal
    centered
    className={styles.container}
    contentClass={styles.modalContent}
    dialogClass={styles.modal}
    dismissModal={closeModal}
    shouldCloseOnEsc={true}
    shouldCloseOnOverlayClick={true}
    size="small"
    withCloseButton={true}>
    <div className={styles.imageContainer}>
      <img alt="" src={CarCelebrate} />
    </div>
    <h5 className={styles.heading}>
      {LocalT.translate('heading')}
    </h5>
    <p className={styles.subtext}>
      {subtext}
    </p>
    <div className={styles.buttonContainer}>
      <Button fullWidth label={LocalT.translate('button')} onClick={closeModal} />
    </div>
  </Modal> : null);
};
